module.exports = __webpack_public_path__ + "static/media/Danone_Italic.15e73935.woff2";